import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputNumber from "../components/Form/UiInputNumber";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function OverloadForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { ativo: true }
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={8} name="chave" label="Marca / Modelo"/>
                        <UiInputNumber size={4} name="fator" label="Overload" mode="decimal" minFractionDigits={1} maxFractionDigits={4}/>
                        <UiInputCheckbox size={3} name="ativo" label="Ativo"/>
                    </div>
                    <p className="text-muted small mb-0">
                        Procurado no nome do inversor, sem espaços, hífens, pontos e vírgulas.
                        Se mais de um bater, vale o mais longo (ex.: 5KTLMG3 ganha de GROWATT).
                    </p>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
